import React, { useEffect, useState } from 'react';
import './CustomerOrderReferenceReplace.scss';
import IconItem from '../../../../../../components/Item/IconItem/IconItem';
import { faArrowLeft, faArrowRight, faClose, faExclamation } from '@fortawesome/free-solid-svg-icons';
import DefaultButton from 'components/buttons/DefaultButton/DefaultButton';
import CURRENCY from 'utils/constants/currency';
import { Trans, useTranslation } from 'react-i18next';
import Pagination from 'components/pagination/Pagination';
import { IImportFileNew, IParts } from 'interfaces/price';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useDispatch } from 'react-redux';
import { setCloseModal } from 'store/slices/proformaAutomotorModal.slice';
import { formatNumberWithSpaces } from 'utils/utils';
import ActionContentElementReplace from './ActionContentReplace/ActionContentElementReplace';
import { notify } from 'utils/marketplace';


type Props = {
  setOpenModal: (e: boolean) => void;
  setStepModal: (e: string) => void;
  stepModalNext: string;
};

type ReplaceItem = {
  reference: string;
  reference_full: string;
  reference_new: string;
  reference_new_full?: string;
  reason: string;
  action_user: string;
  description: string;
};


const CustomerOrderReferenceReplace: React.FC<Props> = (props) => {

  const { t } = useTranslation();
  const proformaFile = JSON.parse(localStorage.getItem('proformaFileInProgress') as string);
  const [data, setData] = useState<Array<IImportFileNew>>([]);
  const user = JSON.parse(localStorage.getItem('userData')!);
  const [dataPagination, setDataPagination] = useState<Array<IParts>>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [itemsPerPage] = useState<number>(5);
  const [totalPages, setTotalPages] = useState<number>(0);
  const [validatePressedRows, setValidatePressedRows] = useState<string[]>([]);
  const [remplaceReferenceOrNFP, setRemplaceReferenceOrNFP] = useState<ReplaceItem[]>([]);

  const dispatch = useDispatch();

  const handleClose = () => {
    props.setOpenModal(false);
    dispatch(setCloseModal(true));
  };

  const handlePageClick = (page: number) => {
    setCurrentPage(page);

  };


  useEffect(() => {
    if (props.stepModalNext === 'CustomerOrderReferenceReplace') {

      const data = proformaFile.partsWithReplacements || [];

      const referenceReplace = data
        .map(item => {
          const filteredParts = item.parts?.filter(part => (part.replace_status === true && part.accepted_replace == undefined)) || [];

          if (filteredParts.length > 0) {
            return {
              ...item,
              parts: filteredParts
            };
          }

          return null;
        })
        .filter(Boolean);

      setData(referenceReplace);
    }

  }, [props.stepModalNext]);


  useEffect(() => {


    if (data.length > 0) {
      const parts = data.map((item) => item.parts).flat();


      const total = parts.length;

      setTotalPages(Math.ceil(total / itemsPerPage));
      const startIndex = (currentPage - 1) * itemsPerPage;
      const endIndex = startIndex + itemsPerPage;

      setDataPagination(parts.slice(startIndex, endIndex));
    }


  }, [data, currentPage, itemsPerPage]);


  const addReferenceSelected = async () => {
    const allParts = data.map((item) => item.parts).flat();

    if (validatePressedRows.length != allParts.length) {
      notify(t('_validation_ref_replace_message_error'), 'error', t('_error'));

      return;
    }

    const mustByReplace = allParts.filter((item) => (item.replaceRef === true && item.newRef));

    const newReplacements = allParts.map(item => ({
      reference: item.replace?.reference || '',
      reference_full: item.replace?.reference_full || '',
      reference_new: item.reference || '',
      reference_new_full: item.reference_full || '',
      reason: item.reference != '-' ? 'replacement' : 'NFP',
      description: (item.reference != '-' ? item.description : item.replace?.description) || '',
      action_user: 'confirmed',
    }));

    let partsValid: IImportFileNew[] = [];

    partsValid = proformaFile.partsWithReplacements;


    mustByReplace.forEach((newItem) => {
      if (newItem.newRef) {

        const replacementIndex = newReplacements.findIndex(
          (rep) => rep.reference === (newItem.replace?.reference || '')
        );

        if (replacementIndex !== -1) {
          newReplacements[replacementIndex].reference_new = newItem.newRef.parts[0].reference || '';
          newReplacements[replacementIndex].reference_new_full = newItem.newRef.parts[0].reference_full || '';
          newReplacements[replacementIndex].reason = newItem.reference != '-' ? 'replacement' : 'NFP';
          newReplacements[replacementIndex].description = (newItem.reference != '-' ? newItem.newRef.parts[0].description : newItem.replace?.description) || '';
        }

        const existingIndex = partsValid.findIndex((item) => {
          return item.code_fou === newItem.newRef?.code_fou;
        });

        if (existingIndex !== -1) {

          const indexRow = partsValid[existingIndex].parts.length;

          newItem.newRef.parts[0].index = indexRow;
          newItem.newRef.parts[0].supplier_name = String(newItem.newRef.parts[0].name);
          newItem.newRef.parts[0].old_reference = newItem.replace?.reference_full || null;
          newItem.newRef.parts[0].quantity = newItem.replace?.quantity || 1;
          newItem.newRef.parts[0].total = (Number(newItem.replace?.total) * Number(newItem.replace?.price)) || 0;
          newItem.newRef.parts[0].accepted_replace = true;
          partsValid[existingIndex].parts = Array.from(new Set([...partsValid[existingIndex].parts, newItem.newRef.parts[0]]));


        } else {
          newItem.newRef.parts[0].quantity = newItem.replace?.quantity || 1;
          newItem.newRef.parts[0].total = (Number(newItem.replace?.quantity) * Number(newItem.newRef.parts[0].price)) || 0;
          newItem.newRef.parts[0].supplier_name = String(newItem.newRef.parts[0].name);
          newItem.newRef.parts[0].old_reference = newItem.replace?.reference_full || null;
          newItem.newRef.parts[0].accepted_replace = true;
          partsValid.push(newItem.newRef);
        }

        //delete item replace
        const { reference, codfou, index } = newItem;


        partsValid = partsValid.map((item) => {
          const updatedParts = item.parts.filter((part) => !(part.reference == reference && part.index == index && part.codfou == codfou));


          return { ...item, parts: updatedParts };
        });


      }


    });

    // Adaugă accepted_replace: true la toate piesele rămase
    partsValid = partsValid.map((item) => ({
      ...item,
      parts: item.parts.map((part) => ({
        ...part,
        accepted_replace: true,
        old_reference: (part.old_reference ? part.old_reference : part.replace?.reference_full) || null,
      })),
    }));

    const updatedProformaFile = {
      ...proformaFile,
      partsWithReplacements: partsValid.filter((item) => Array.isArray(item.parts) && item.parts.length !== 0),
      remplace_or_nfp_reference: [...remplaceReferenceOrNFP, ...newReplacements],
    };

    localStorage.setItem('proformaFileInProgress', JSON.stringify(updatedProformaFile));
    setTimeout(() => {
      props.setStepModal('ValidationReferencesNotFound');
    }, 0);

    setRemplaceReferenceOrNFP(prev => [...prev, ...newReplacements]);
  };


  return (
    <div className="validation-custumer-replace-modal" >
      <div className="close">
        <IconItem icon={faClose} onClick={() => { handleClose(); }} />
      </div>


      <div className="validation-customer-modal-body">
        <div className="validation-customer-modal-row">
          <div className="validation-customer-modal-title">
            <div className="validation-icon-container">
              <div className="validation-icon">
                <FontAwesomeIcon icon={faExclamation} />
              </div>
            </div>
            {t('_validation_ref_replace')}
          </div>
          <div className="validation-customer-modal-subtitle">
            <Trans
              i18nKey="_validation_ref_replace_message"
              components={{ bold: <br /> }}

            />
          </div>
        </div>
        <div className="validation-customer-modal-row">

          <table className="validation-customer-modal-table">
            <thead>
              <tr >

                <th className="text-align-left"> {t('_ref_old')} / {t('_description')} </th>
                <th >{t('_brand')}</th>
                <th>{t('_reason')}</th>

                <th >{t('_requested_unit_price')}</th>
                <th></th>

              </tr>
            </thead>
            <tbody>
              {data.length > 0 ? (
                dataPagination.map((row) => (
                  <tr key={row.index}>

                    <td className="text-align-left">{row.replace?.reference} / {row.description} </td>
                    <td>
                      <img src={row?.supplier_logo ? row?.supplier_logo : '/images/car-part-placeholder-big.png'} onError={({ currentTarget }) => {
                        currentTarget.onerror = null;
                        currentTarget.src = '/images/car-part-placeholder-big.png';
                      }} alt="provider-logo" height={16}
                      />
                    </td>
                    <td>{row.reference != '-' ? t('_replacement') : t('_replacement_or_NFP')} </td>
                    <td>{row.price_from_file ? `${formatNumberWithSpaces(Number(row.price_from_file).toFixed(2))} ${CURRENCY[user!.currency]}` : '-'} </td>
                    <td className="action">
                      <ActionContentElementReplace
                        itemsPerPage={itemsPerPage}
                        setCurrentPage={setCurrentPage}
                        currentPage={currentPage}
                        index={row.index!}
                        item={row}
                        rowsData={data}
                        setData={setData}
                        setValidatePressedRows={setValidatePressedRows}
                        setStepModal={props.setStepModal}
                        showReplace={row.reference != '-' ? true : false}
                        validatePressedRows={validatePressedRows}
                        setRemplaceReferenceOrNFP={setRemplaceReferenceOrNFP}


                      />
                    </td>

                  </tr>)))
                :
                <tr>
                  <td colSpan={5} className="no-data">{t('_no_data')}</td>
                </tr>
              }


            </tbody>
          </table>
          {totalPages > 1 && (
            <Pagination pageCount={totalPages} handlePageClick={handlePageClick} forcePage={currentPage} hiddenParamPage iconsPrevious={faArrowLeft} iconsNext={faArrowRight} />
          )}
        </div>
        <div className="validation-customer-modal-row">
          <div className="validation-customer-modal-button">
            <DefaultButton className="validation-customer-modal-btn" text={t('_accept_new_references')} onClick={() => { addReferenceSelected(); }} />
            <DefaultButton className="validation-customer-modal-btn cancel" text={t('_cancel')} onClick={() => { handleClose(); }} />

          </div>

        </div>

      </div>
    </div>
  );
};

CustomerOrderReferenceReplace.displayName = 'CustomerOrderReferenceReplace';

export default CustomerOrderReferenceReplace;